import styled from 'styled-components/macro';
import { Link } from '~/components';

export const MainContainer = styled.div`
  width: 100%;
  height: 100%;
`;

export const HeaderContainer = styled.div`
  width: 100%;
  height: auto;
`;

export const MainHeader = styled.div`
  height: 46px;
  width: 100%;
  background-color: ${({ theme, competition }) =>
    competition === 1 ? theme.coral : theme.turquoise};
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-right: 50px;
  @media (max-width: ${({ theme }) => theme.breakpoints.xl}px) {
    padding-right: 5px;
  }
`;

export const GoBackButton = styled(Link)`
  width: 200px;
  height: 100%;
  background-color: ${({ theme }) => theme.white};
  border-top: 2px solid
    ${({ theme, competition }) =>
      competition === 1 ? theme.coral : theme.turquoise};
  padding-left: 50px;
  display: flex;
  align-items: center;
  transition: background-color 0.3s;
  @media (max-width: ${({ theme }) => theme.breakpoints.xl}px) {
    padding-left: 5px;
    padding-right: 5px;
    width: auto;
  }
`;

export const ButtonLabel = styled.p`
  margin: 0;
  font-size: ${({ theme }) => theme.paragraph}px;
  font-family: ${({ theme }) => theme.primaryFont};
  color: ${({ theme }) => theme.black};
  padding-left: 10px;
  text-align: left;

  span {
    font-size: ${({ theme }) => theme.h5}px;
    font-family: ${({ theme }) => theme.primaryFontBold};
  }
`;

export const HeaderItem = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  @media (max-width: ${({ theme }) => theme.breakpoints.xl}px) {
    & svg {
      width: 15px;
      height: 15px;
    }
  }
`;

export const HeaderItemLogo = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  img {
    height: 65%;
  }
`;

export const HeaderItemLabel = styled.div`
  margin: 0;
  font-size: ${({ theme }) => theme.paragraph}px;
  font-family: ${({ theme }) => theme.primaryFont};
  color: ${({ theme }) => theme.white};
  padding-left: 10px;
  text-align: left;

  span {
    font-size: ${({ theme }) => theme.h5}px;
    font-family: ${({ theme }) => theme.primaryFontBold};
    @media (max-width: ${({ theme }) => theme.breakpoints.xl}px) {
      font-size: 12px;
    }
  }
`;

export const MatchScore = styled.div`
  height: 54px;
  width: 100%;
  background-color: ${({ theme }) => theme.white};
  display: flex;
`;

export const TeamScore = styled.div`
  display: flex;
  align-items: center;
  flex-direction: ${({ type }) => (type === 'local' ? 'row' : 'row-reverse')};
  justify-content: space-between;
  width: 50%;
  height: 100%;
  background-color: ${({ theme, type }) =>
    type === 'local' ? theme.white : theme.dark5};
  padding: 20px;
  font-size: ${({ theme }) => theme.h3}px;
  font-family: ${({ theme }) => theme.primaryFontHead};

  span {
    font-size: ${({ theme }) => theme.h1}px;
    font-family: ${({ theme }) => theme.primaryFontHeadBold};
    color: ${({ theme, type }) =>
      type === 'local' ? theme.dark : theme.white};
  }
`;

export const TeamContainer = styled.div`
  text-transform: uppercase;
  display: flex;
  align-items: center;
  flex-direction: ${({ type }) => (type === 'local' ? 'row' : 'row-reverse')};
  height: 100%;
  color: ${({ theme, type }) => (type === 'local' ? theme.dark : theme.white)};
  flex: 1;
  justify-content: center;
  font-family: ${({ theme }) => theme.primaryFontHeadBold};
  font-size: ${({ theme }) => theme.headerTitle}px;

  img {
    height: ${({ theme }) => theme.shieldMedium}px;
    margin: ${({ type }) => (type === 'local' ? '0 0 0 10px' : '0 10px 0 0')};
  }
`;

export const SubRouteContainer = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 100%;
  grid-template-rows: auto 1fr;
  min-height: 100%;
  @media (max-width: ${({ theme }) => theme.breakpoints.md}px) {
    display: flex;
  }
`;

export const SubRouteContainerSm = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 100%;
  grid-template-rows: 1fr;
  min-height: 100%;
  @media (max-width: ${({ theme }) => theme.breakpoints.md}px) {
    display: flex;
  }
`;

export const SubRouteNavBar = styled.div`
  width: 100%;
  height: 38px;
  background-color: ${({ theme, background }) => theme[background]};
  display: flex;
  justify-content: center;
`;

export const SubRouteNavBarOption = styled.button`
  border-style: ${({ isSelected }) => (isSelected ? 'solid' : 'none')};
  border-color: ${({ theme, borderColor }) => theme[borderColor]};
  border-width: 0 0 3px 0;
  height: 100%;
  width: 220px;
  font-family: ${({ theme, isSelected }) =>
    isSelected ? theme.primaryFontBold : theme.primaryFontMedium};
  background-color: transparent;
`;
